import { Center, Space } from "@mantine/core";
import { CTAVideoBanner } from "../CTAVideoBanner/CTAVideoBanner";
import { CommunityReviews } from "../CommunityReviews/CommunityReviews";
import { FeatureCardList } from "../FeatureCardList/FeatureCardList";
import { HeroTitle } from "../HeroTitle/HeroTitle";
import { AppCard } from "../AppCards/AppCards";

import { AppCardList } from "../AppCards/AppCardList";

export default function BodyContent({logged_in}: { logged_in: boolean }): React.JSX.Element {
  return (
    <>
      <HeroTitle />
      <Space h="xl" />
      <Space h="xl" />
      <Center>
      <AppCardList/>
      </Center>
    </>
  );
}
